module.exports = "<form>\r\n  <spk-card title=\"Search Countries\">\r\n    <spk-checkbox wrappedClass=\"pull-right\" name=\"showInactive\" [(model)]=\"showInactive\" (modelChange)=\"setFilterSpecification()\"></spk-checkbox>\r\n    <spk-search-grid #grid defaultSortProperty=\"Name ASC\" list=\"CountrySearchRow\" [leftLinks]=\"leftLinks\" [filter]=\"filter\"></spk-search-grid>\r\n  </spk-card>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/countries/countries/countries.component.html
// module id = ./src/app/components/admin/countries/countries/countries.component.html
// module chunks = main